// extracted by mini-css-extract-plugin
export default {"container":"promotion-modal_container__342AX","card":"promotion-modal_card__3bGcr"};